import React, { useState, useEffect, useContext } from "react";
import useApi from "../../../../utils/api-manager/Helper/useApi";
import AuthContext from "../../../../utils/secure-route/AuthContext";
import { useToastHandler } from "../../../common/ToastHandler";
import { useConfig } from '../../../../context/ConfigContext'
import { ToastContainer } from "react-toastify";
import "./Configuration.css";
const Configuration = () => {
  const [selectedCurrency, setSelectedCurrency] = useState("USD");
  const [selectedTimeZone, setSelectedTimeZone] = useState("UTC");
  const [selectedPhoneCode, setSelectedPhoneCode] = useState("+1");
  const [selectedDateFormat, setSelectedDateFormat] = useState("");
  const [selectedPayMethod, setSelectedPayMethod] = useState("cash");
  const [, setTimes] = useState({});
  const [configurationId, setConfigurationId] = useState(null);
  const { Get, Post, Patch, GetPaginatedData } = useApi();
  const { user } = useContext(AuthContext);

  const { handleToast } = useToastHandler()
  const { config, setDateFormat, setCurrency, setStoreId } = useConfig();
  const storeId = config.storeId;

  const currencyOptions = [
    { code: "INR", symbol: "₹", name: "Indian Rupee" },
    { code: "USD", symbol: "$", name: "US Dollar" },
    { code: "CAD", symbol: "C$", name: "Canadian Dollar" },
    { code: "AUD", symbol: "A$", name: "Australian Dollar" },
    { code: "GBP", symbol: "£", name: "British Pound" },
    { code: "EUR", symbol: "€", name: "Euro" },
    { code: "AED", symbol: "د.إ", name: "UAE Dirham" },
    { code: "SGD", symbol: "S$", name: "Singapore Dollar" },
    { code: "NZD", symbol: "NZ$", name: "New Zealand Dollar" },
    { code: "JPY", symbol: "¥", name: "Japanese Yen" },
    { code: "CNY", symbol: "¥", name: "Chinese Yuan" },
    { code: "ZAR", symbol: "R", name: "South African Rand" },
  ];

  const timeZoneOptions = [
    { code: "UTC", name: "UTC (GMT +0:00)" },
    { code: "Asia/Kolkata", name: "India - IST (GMT +5:30)" },
    { code: "Asia/Dubai", name: "Dubai - GST (GMT +4:00)" },
    { code: "Asia/Singapore", name: "Singapore - SGT (GMT +8:00)" },
    { code: "Asia/Tokyo", name: "Tokyo - JST (GMT +9:00)" },
    { code: "Europe/London", name: "London - GMT/BST" },
    { code: "Europe/Paris", name: "Paris - CET/CEST" },
    { code: "America/New_York", name: "New York - ET" },
    { code: "America/Chicago", name: "Chicago - CT" },
    { code: "America/Denver", name: "Denver - MT" },
    { code: "America/Phoenix", name: "Phoenix - MST" },
    { code: "America/Los_Angeles", name: "Los Angeles - PT" },
    { code: "Canada/Atlantic", name: "Canada Atlantic - AT" },
    { code: "Australia/Sydney", name: "Sydney - AEST/AEDT" },
    { code: "Pacific/Auckland", name: "Auckland - NZST/NZDT" },
  ];

  const phoneCodeOptions = [
    { code: "+91", name: "India (+91)" },
    { code: "+1", name: "USA / Canada (+1)" },
    { code: "+44", name: "United Kingdom (+44)" },
    { code: "+61", name: "Australia (+61)" },
    { code: "+64", name: "New Zealand (+64)" },
    { code: "+971", name: "UAE (+971)" },
    { code: "+65", name: "Singapore (+65)" },
    { code: "+81", name: "Japan (+81)" },
    { code: "+86", name: "China (+86)" },
    { code: "+27", name: "South Africa (+27)" },
  ];

  function getTimeInTimeZone(timeZone) {
    const options = {
      timeZone,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    };
    return new Date().toLocaleString("en-US", options);
  }

  const dateFormatOptions = [
    { value: "DD/MM/YYYY", label: "DD/MM/YYYY" },
    { value: "MM/DD/YYYY", label: "MM/DD/YYYY" },
    { value: "YYYY/MM/DD", label: "YYYY/MM/DD" },
    { value: "DD-MM-YYYY", label: "DD-MM-YYYY" },
    { value: "MM-DD-YYYY", label: "MM-DD-YYYY" },
    { value: "YYYY-MM-DD", label: "YYYY-MM-DD" },
    { value: "DD MMM YYYY", label: "23 Jul 2026" },
    { value: "MMM DD, YYYY", label: "Jul 23, 2026" },
    { value: "MMMM D, YYYY", label: "July 23, 2026" },
  ];
  const handleDateFormatChange = (e) => {
    const newDisplayValue = e.target.value;
    setSelectedDateFormat(newDisplayValue);

    const backendValue = dateFormatOptions.find(opt => opt.value === newDisplayValue)?.value || "MM-DD-YYYY";
    setDateFormat(backendValue);
  };

  useEffect(() => {
    const updatedTimes = {};
    timeZoneOptions.forEach((zone) => {
      updatedTimes[zone.code] = getTimeInTimeZone(zone.code);
    });
    setTimes(updatedTimes);
  }, [selectedTimeZone]);

  const handleChange = (setter) => (e) => {
    setter(e.target.value);
  };

  const handleReset = () => {
    const defaultCurrency = "USD";
    const defaultTimeZone = "UTC";
    const defaultPhoneCode = "+1";
    const defaultDateFormat = "MM-DD-YYYY";

    setSelectedCurrency(defaultCurrency);
    setSelectedTimeZone(defaultTimeZone);
    setSelectedPhoneCode(defaultPhoneCode);
    setSelectedDateFormat(defaultDateFormat);
    setSelectedPayMethod("cash");

    setCurrency(defaultCurrency);
    setDateFormat(defaultDateFormat);
  };

  useEffect(() => {
    if (user?.store && user.store !== storeId) {
      setStoreId(user.store);
    }
  }, [user?.store, storeId, setStoreId]);

  useEffect(() => {

    setSelectedCurrency("USD");
    setSelectedTimeZone("UTC");
    setSelectedPhoneCode("+1");
    setSelectedDateFormat("MM-DD-YYYY");
    setSelectedPayMethod("cash");
    // setConfigurationId(null);

    if (storeId) {
      fetchUserData();
    }
  }, [storeId]); 

  const applyStoreConfiguration = (storeConfiguration) => {
    if (!storeConfiguration) {
      setSelectedDateFormat("MM-DD-YYYY");
      setDateFormat("MM-DD-YYYY");
      setCurrency("USD");
      setSelectedPayMethod("cash");
      return null;
    }

    setConfigurationId(storeConfiguration.id || null);
    setSelectedCurrency(storeConfiguration.currency || "USD");
    setSelectedTimeZone(storeConfiguration.time_zone || "UTC");
    setSelectedPhoneCode(storeConfiguration.contact_no_code || "+1");
    setSelectedPayMethod(storeConfiguration.default_pay_method || "cash");

    const backendFormat = storeConfiguration.date_format || "MM-DD-YYYY";
    const displayFormat = dateFormatOptions.find(opt => opt.value === backendFormat)?.value || "MM-DD-YYYY";
    setSelectedDateFormat(displayFormat);
    setDateFormat(backendFormat);
    setCurrency(storeConfiguration.currency || "USD");

    return storeConfiguration;
  };

  const fetchUserData = async () => {
    try {
      if (storeId) {
        const configurationResponse = await GetPaginatedData("configurationForStore", {
          queryParams: { store: storeId },
        });
        const storeConfiguration = configurationResponse?.data?.[0];

        if (storeConfiguration) {
          return applyStoreConfiguration(storeConfiguration);
        }

        const response = await Get("checkUserType", { store_id: storeId });
        return applyStoreConfiguration(response?.store_configuration);
      }
    } catch (error) {
      console.error("Failed to fetch user data:", error);
    
    }

    return null;
  };

  const handleSave = async () => {
    if (!storeId) {
      handleToast({ type: "ERROR", message: "Store ID not found!" });
      return;
    }

    const payload = {
      store: storeId,
      currency: selectedCurrency,
      time_zone: selectedTimeZone,
      contact_no_code: selectedPhoneCode,
      date_format: selectedDateFormat, 
      default_pay_method: selectedPayMethod,
    };

    try {
      const existingConfiguration = configurationId ? { id: configurationId } : await fetchUserData();
      const existingConfigurationId = existingConfiguration?.id;

      if (!existingConfigurationId) {
        const response = await Post("configurationForStore", payload);
        setConfigurationId(response?.data?.id || null);
      } else {
        await Patch("configurationForStore", existingConfigurationId, payload);
      }

      setCurrency(payload.currency);
      setDateFormat(payload.date_format);
      setSelectedTimeZone(payload.time_zone);
      setSelectedPhoneCode(payload.contact_no_code);
      setSelectedDateFormat(payload.date_format);
      setSelectedPayMethod(payload.default_pay_method);

      await fetchUserData(); 

      handleToast({ type: "SUCCESS", message: "Configuration saved successfully!" });
    } catch (error) {
      const duplicateStoreConfig = error?.response?.status === 400 && error?.response?.data?.store;
      if (duplicateStoreConfig) {
        const existingConfiguration = await fetchUserData();
        if (existingConfiguration?.id) {
          try {
            await Patch("configurationForStore", existingConfiguration.id, payload);
            setCurrency(payload.currency);
            setDateFormat(payload.date_format);
            setSelectedTimeZone(payload.time_zone);
            setSelectedPhoneCode(payload.contact_no_code);
            setSelectedDateFormat(payload.date_format);
            setSelectedPayMethod(payload.default_pay_method);
            await fetchUserData();
            handleToast({ type: "SUCCESS", message: "Configuration saved successfully!" });
            return;
          } catch (patchError) {
            console.error("Failed to update existing configuration:", patchError);
          }
        }
      }

      console.error("Failed to save configuration:", error);
      handleToast({ type: "ERROR", message: error?.response?.data?.detail || error?.response?.data?.message || "Failed to save configuration" });
    }
  };

  return (
    <div className="responsive-box store-config-panel">
      <ToastContainer />
      <div className="store-config-header">
        <div>
          <span className="store-config-kicker">Store preferences</span>
          <h2>Configuration</h2>
          <p>Control the default format and regional settings used across your store workspace.</p>
        </div>
        <button
          type="button"
          className="store-config-reset"
          onClick={handleReset}
        >
          Reset to Default
        </button>
      </div>

      <div className="store-config-grid">
        <div className="store-config-field">
          <div>
            <label htmlFor="store-date-format">Date Format</label>
            <span>Used on invoices, reports and history pages.</span>
          </div>
          <select
            id="store-date-format"
            value={selectedDateFormat}
            onChange={handleDateFormatChange}
          >
            {dateFormatOptions.map((format) => (
              <option key={format.value} value={format.value}>
                {format.label}
              </option>
            ))}
          </select>
        </div>

        <div className="store-config-field">
          <div>
            <label htmlFor="store-currency">Currency</label>
            <span>Default money symbol and code for store values.</span>
          </div>
          <select
            id="store-currency"
            value={selectedCurrency}
            onChange={handleChange(setSelectedCurrency)}
          >
            {currencyOptions.map((currency) => (
              <option key={currency.code} value={currency.code}>
                {currency.symbol} ({currency.code}) - {currency.name}
              </option>
            ))}
          </select>
        </div>

        <div className="store-config-field">
          <div>
            <label htmlFor="store-time-zone">Time Zone</label>
            <span>Used for shift, invoice and report timestamps.</span>
          </div>
          <select
            id="store-time-zone"
            value={selectedTimeZone}
            onChange={handleChange(setSelectedTimeZone)}
          >
            {timeZoneOptions.map((zone) => (
              <option key={zone.code} value={zone.code}>
                {zone.name}
              </option>
            ))}
          </select>
        </div>

        <div className="store-config-field">
          <div>
            <label htmlFor="store-phone-code">Phone Code</label>
            <span>Default country code for phone inputs.</span>
          </div>
          <select
            id="store-phone-code"
            value={selectedPhoneCode}
            onChange={handleChange(setSelectedPhoneCode)}
          >
            {phoneCodeOptions.map((phoneCode) => (
              <option key={phoneCode.code} value={phoneCode.code}>
                {phoneCode.name}
              </option>
            ))}
          </select>
        </div>

        <div className="store-config-field">
          <div>
            <label htmlFor="store-default-pay-method">Default Payment Method</label>
            <span>Primary checkout payment option for invoices and POS.</span>
          </div>
          <select
            id="store-default-pay-method"
            value={selectedPayMethod}
            onChange={handleChange(setSelectedPayMethod)}
          >
            <option value="cash">Cash</option>
            <option value="bank">Bank Card</option>
            <option value="cheque">Cheque</option>
            <option value="terminal">Payment Terminal</option>
          </select>
        </div>
      </div>

      <div className="store-config-preview">
        <div>
          <span>Current currency</span>
          <strong>{selectedCurrency}</strong>
        </div>
        <div>
          <span>Date format</span>
          <strong>{dateFormatOptions.find((format) => format.value === selectedDateFormat)?.label || selectedDateFormat}</strong>
        </div>
        <div>
          <span>Time zone</span>
          <strong>{timeZoneOptions.find((zone) => zone.code === selectedTimeZone)?.name || selectedTimeZone}</strong>
        </div>
        <div>
          <span>Phone code</span>
          <strong>{selectedPhoneCode}</strong>
        </div>
        <div>
          <span>Default Payment</span>
          <strong>{selectedPayMethod === "bank" ? "Bank Card" : selectedPayMethod === "terminal" ? "Payment Terminal" : selectedPayMethod.charAt(0).toUpperCase() + selectedPayMethod.slice(1)}</strong>
        </div>
        <div>
          <span>Store ID</span>
          <strong>{storeId || "Not selected"}</strong>
        </div>
      </div>

      <div className="store-config-actions">
        <button
          type="button"
          className="store-config-save"
          onClick={handleSave}
        >
          Save Configuration
        </button>
      </div>
    </div>

  );
};

export default Configuration;
